import type { FunctionComponent } from 'react';
import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useSelector } from 'react-redux';

import { config } from '../../../config/config';
import { useGeoLocationHeartbeat } from '../../geolocation/hooks/use-geolocation-heartbeat';
import { useLayout } from '../../main/util/layout-context';
import { BlockType, useCompliancePrompt } from '../../sessions/hooks/use-compliance-prompt';
import { Loader } from '../../shared/components/loader/loader';
import { useCurrentCurrency } from '../../shared/hooks/use-current-currency';
import { selectLanguage } from '../../shared/store/locale.store';
import { SportNCo } from '../components/sportnco/sportnco';
import { useGetSportsLaunchUrlQuery } from '../queries/launch-sports.graphql';

export interface ISportbookProps {
    selectedSportsbook?: 'sportnco';
}

export const Sports: FunctionComponent<ISportbookProps> = () => {
    useLayout({
        title: 'Sports',
        showNavButtons: true,
        isFullWidth: true,
    });

    const { sendHeartbeat } = useGeoLocationHeartbeat();

    const auth = useAuth();
    const currency = useCurrentCurrency();
    const language = useSelector(selectLanguage);
    const profileId = auth.user?.profile.user_profile_id as string;

    const [{ data, fetching, error }] = useGetSportsLaunchUrlQuery({
        pause: auth.isLoading,
        // ||(status !== GeoLocationStatus.ALLOWED &&
        //  config.GEOLOCATION.ENHANCED_GEOLOCATION_REQUIRED.SPORTS),
        variables: {
            xTenantID: config.TENANT_ID,
            userProfileId: profileId,
            currency,
            language,
            isDemoPlay: !profileId,
            sportsbookIntegration: 'sportnco',
        },
        requestPolicy: 'network-only',
    });
    const result = data?.getSportsLaunchUrl;

    useEffect(() => {
        if (result) {
            sendHeartbeat();
        }
    }, [result, sendHeartbeat]);

    const { prompt } = useCompliancePrompt(BlockType.WAGER);



    if (fetching || !result || error) {
        return <Loader />;
    }

    return (
        <>
            {prompt}
            <SportNCo launchUrl={result.url} sessionId={result.sessionContextId || ''} />
        </>
    );
};
